import { getInstance } from "./index";
import {store} from '../store/index'

export const authGuard = (to, from, next) => {
    const authService = getInstance();

    const fn = () => {
        // If the user is authenticated, continue with the route
        if (authService.isAuthenticated) {

            let user = store.getters['userAccount/current'];
            if (user) {
                //require agreements
                if(!user.termsAccepted) {
                    return next({name: 'Agreement' , params: {agreementType: 'termsOfUse'}});
                } else if(!user.privacyAccepted) {
                    return next({name: 'Agreement' , params: {agreementType: 'privacy'} });
                }
            }

            return next();
        }

        if (!from || from.name !== 'Login' || from.name !== 'ViewAgreement' || !authService.loading) {
            //otherwise redirect to login page
            return next({name: 'Login', params: { redirectPath: to.path } });
        }
    };

    return fn();
};